import { API_ROOT } from '../../constants';

export const CREATE_ORDER_URL = `${API_ROOT}/ebon/order`;

export const PAYMENT_SESSION_URL = `${API_ROOT}/payment-solution/apple/payment-session`;
export const PAY_URL = `${API_ROOT}/payment-solution/apple/pay`;



// WEBPACK FOOTER //
// ./src/services/applepay/constants.js